import { apiGet, apiPost } from '@ibkr/clientportal.common/src/api/default'

/**
 * key: unrealized_pnl id: 75
 * key: last_price id: 31
 * key: close_price id: 7296
 * key: market_data_availability id: 6509
 * key: change_price id: 82
 * key: bid_price id: 84
 * key: change_percent id: 83
 * key: ask_size id: 85
 * key: bid_size id: 88
 */

const base = process.env.MDFARM_BASE_URL || '';

let counter = 0;

const authenticate = (data) => {
    return apiGet(base + '/md/auth/init');
}

/**
 * @Deprecated
 * Sends a request to get market data for conids
 */
const  subscribe = (conids, { since=1, fields }) => {
    let query = '/iserver/marketdata/subscribe?conids=' + conids + '&since=' + since;
    if (fields) {
        query += '&fields=' + fields;
    }
    return apiGet(base + query);
}

/**
 * Sends a request to get market data for a conids
 * data contains list of 'conids' and 'fields' and boolean 'backout'
 */
const getSnapshot = (data) => {
    return apiPost(base + '/iserver/marketdata/snapshot', data);
}

/**
 * Fetches RegSnapshot from MD farm
 */
const getRegsnapshot = (conid) => {
    return apiGet(`${base}/md/regsnapshot?conid=${conid}&fields=31,84,85,86,88,7057,7058,7059,7067,7068`);
}


const getNewSnapshot = ({conids, fields}) => {
    return apiGet(`${base}/md/snapshot?conids=${conids}&fields=${fields}`);
}

/**
 * Provides market data for all the conids which are currently subscribed
 */
const getMarketData = () => {
    return apiGet(base + '/iserver/marketdata' );
}

/**
 * Provides market data for for given conid over websocket
 */
const subscribeUpdates = ({ conid, fields, backout }, { onUpdates }) => {
    if (!conid) {
        return;
    }
    if (!window.ibrt) {
        console.error('mdapi: real-time api missing');
        return;
    }

    const args = { fields, backout };

    return window.ibrt.subscribeArgs('smd+' + conid, 'MD', args, { onMessage: onUpdates });
}

const newSubscribeUpdates = ({ conid, fields }, { onUpdates }) => {
    if (!conid) {
        return;
    }
    if (!window.ibrt) {
        console.error('mdapi: real-time api missing');
        return;
    }

    const args = { fields };

    return window.ibrt.subscribeArgs('mds+' + conid, 'MD', args, { onMessage: onUpdates });
}

/**
 * Unsubscibes market data subscriptions for given conids
 */
const unsubscribeMarketData = (conids) => {
    if (!conids || !conids.length) {
        return;
    }
    return apiPost(base + '/iserver/marketdata/unsubscribe', { conids: conids });
}

/**
 * Unsubscibes all the current market data subscriptions
 */
const unsubscribeAllMarketData = () => {
    return apiGet(base + '/iserver/marketdata/unsubscribeall' );
}

const newUnsubscribeAllMD = () => {
    return apiGet(base + '/md/unsubscribe/all' );
}

const getHistoryDataDirectHMDS = ({ conid, period, bar, outsideRth, startTime, direction }, { onUpdates, onHistoryDataError }) => {
    if (!conid) {
        return;
    }
    if (!window.ibrt) {
        console.error('mdapi: real-time api missing');
        return;
    }

    const topic = 'rdh+' + conid;
    const requestId = counter++;
    const args = { period, bar, outsideRth, startTime, direction, requestId };

    return window.ibrt.subscribeArgs(
            topic,
            'HD',
            args,
            {
                onMessage: function(res) {
                    const payload = JSON.parse(res?.payload);
                    if (topic == res?.topic && requestId == payload?.requestId) {
                        window.ibrt.newCancelSubscriptions(topic, args);
                        if (res?.error) {
                            return onHistoryDataError(res);
                        } else {
                            return onUpdates(res);
                        }
                    } else {
                        return;
                    }
                },
                onError: onHistoryDataError
            }
        );
}

const getHistoryDataIserver = ({ conid, period, bar, outsideRth, startTime, direction }, { onUpdates, onHistoryDataError }) => {
    if (!conid) {
        return;
    }
    if (!window.ibrt) {
        console.error('mdapi: real-time api missing');
        return;
    }

    const topic = 'hdr+' + conid;
    const requestId = counter++;
    const args = { period, bar, outsideRth, startTime, direction, requestId };

    return window.ibrt.subscribeArgs(
            topic,
            'HD',
            args,
            {
                onMessage: function(res) {
                    const payload = JSON.parse(res?.payload);
                    if (topic == res?.topic && requestId == payload?.requestId) {
                        window.ibrt.newCancelSubscriptions(topic, args);
                        if (res?.error) {
                            return onHistoryDataError(res);
                        } else {
                            return onUpdates(res);
                        }
                    } else {
                        return;
                    }
                },
                onError: onHistoryDataError
            }
        );
}

export default {
    authenticate,
    newSubscribeUpdates,
    subscribeUpdates,
    subscribe,
    getSnapshot,
    getNewSnapshot,
    getMarketData,
    unsubscribeMarketData,
    unsubscribeAllMarketData,
    newUnsubscribeAllMD,
    getHistoryDataDirectHMDS,
    getHistoryDataIserver,
    getRegsnapshot
}
